import LayoutNoMenu from '@/layout/defaultNoMenu';

const protocalRouter = {
    path: '/protocal',
    name: 'protocal',
    component: LayoutNoMenu,
    children: [
        {
            path: 'rule/:fater_id/:son_id', 
            name: 'protocalRule',
            component: () => import('@/views/protocal/rule.vue')
        },
        {
            path: 'rule/detail/:rule_id', 
            name: 'protocalRuleDetail',
            component: () => import('@/views/protocal/ruleDetail/_id.vue')
        },
        {
            path: ':fater_id/:son_id', 
            name: 'protocal',
            component: () => import('@/views/protocal/_id.vue')
        },
    ]
}

export default protocalRouter
